import apiFetch from '../apiFetch'

export default function (token, file, userId) {
  const formData = new FormData()
  formData.append(file.name, file)
  return apiFetch({ endPoint: `UploadSignUser/?userId=${userId}`, method: 'POST', body: formData, token: token, fileBody: true })
}
